import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon, BarChart3Icon, UsersIcon, ShieldIcon, FileTextIcon } from 'lucide-react';
import Button from '../components/Button';
import Card from '../components/Card';
const LandingPage = () => {
  return <div className="max-w-6xl mx-auto" data-id="element-1920">
      <section className="mb-12" data-id="element-1921">
        <div className="text-center mb-8" data-id="element-1922">
          <h1 className="text-3xl md:text-4xl font-bold mb-4 text-secondary" data-id="element-1923">
            Beyond Finance. Building Communities.
          </h1>
          <p className="text-lg text-neutral-400 max-w-2xl mx-auto" data-id="element-1924">
            We are closing the MSME financing gap by connecting Malaysia's most
            ambitious businesses with investors who want to make a real-world
            impact.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-1925">
          <Card className="bg-gradient-to-br from-primary to-primary-dark text-white" data-id="element-1926">
            <h3 className="text-xl font-bold mb-3" data-id="element-1927">For MSME Owners</h3>
            <p className="mb-6" data-id="element-1928">
              Access capital for your business growth through Shariah-compliant
              financial products.
            </p>
            <Link to="/dashboard/msme" data-id="element-1929">
              <Button variant="outline" className="border-white text-white hover:bg-primary-dark hover:text-primary" icon={<ArrowRightIcon className="w-4 h-4" data-id="element-1931" />} iconPosition="right" data-id="element-1930">
                Fund Your Growth
              </Button>
            </Link>
          </Card>
          <Card className="bg-gradient-to-br from-secondary to-secondary-dark text-white" data-id="element-1932">
            <h3 className="text-xl font-bold mb-3" data-id="element-1933">For Impact Investors</h3>
            <p className="mb-6" data-id="element-1934">
              Discover ethical, Shariah-compliant investment opportunities with
              real community impact.
            </p>
            <Link to="/dashboard/investor" data-id="element-1935">
              <Button variant="outline" className="border-white text-white hover:bg-secondary-dark hover:text-secondary" icon={<ArrowRightIcon className="w-4 h-4" data-id="element-1937" />} iconPosition="right" data-id="element-1936">
                Invest with Impact
              </Button>
            </Link>
          </Card>
        </div>
      </section>
      <section className="mb-12" data-id="element-1938">
        <div className="text-center max-w-4xl mx-auto" data-id="element-1939">
          <h2 className="text-2xl font-bold mb-8 text-secondary" data-id="element-1940">
            A Simple Path to Shared Success
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-1941">
            <Card className="flex flex-col items-center justify-center p-6" data-id="element-1942">
              <div className="w-12 h-12 rounded-full bg-primary bg-opacity-10 flex items-center justify-center mb-4" data-id="element-1943">
                <BarChart3Icon className="w-6 h-6 text-primary" data-id="element-1944" />
              </div>
              <h3 className="font-medium mb-3" data-id="element-1945">Step 1: Businesses Apply</h3>
              <p className="text-sm text-neutral-400" data-id="element-1946">
                Eligible MSMEs apply in minutes using their real sales data, not
                paperwork, to get access to Shariah-compliant financing.
              </p>
            </Card>
            <Card className="flex flex-col items-center justify-center p-6" data-id="element-1947">
              <div className="w-12 h-12 rounded-full bg-secondary bg-opacity-10 flex items-center justify-center mb-4" data-id="element-1948">
                <UsersIcon className="w-6 h-6 text-secondary" data-id="element-1949" />
              </div>
              <h3 className="font-medium mb-3" data-id="element-1950">Step 2: Investors Fund</h3>
              <p className="text-sm text-neutral-400" data-id="element-1951">
                Impact-driven investors browse vetted opportunities and fund the
                businesses they believe in, starting their journey of ethical
                returns and community engagement
              </p>
            </Card>
            <Card className="flex flex-col items-center justify-center p-6" data-id="element-1952">
              <div className="w-12 h-12 rounded-full bg-accent bg-opacity-10 flex items-center justify-center mb-4" data-id="element-1953">
                <ShieldIcon className="w-6 h-6 text-accent" data-id="element-1954" />
              </div>
              <h3 className="font-medium mb-3" data-id="element-1955">Step 3: Communities Grow</h3>
              <p className="text-sm text-neutral-400" data-id="element-1956">
                Businesses expand, jobs are created, and investors earn returns
                while participating in the success of the local economy.
              </p>
            </Card>
          </div>
        </div>
      </section>
      <section data-id="element-1957">
        <div className="bg-neutral-50 border border-neutral-100 rounded-lg p-6 text-center" data-id="element-1958">
          <h2 className="text-xl font-bold mb-3 text-secondary" data-id="element-1959">
            Join the Movement to Reshape Islamic Finance.
          </h2>
          <p className="text-neutral-400 mb-6" data-id="element-1960">
            Explore our Shariah-compliant financial platform designed for
            Malaysian MSMEs and impact investors.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4" data-id="element-1961">
            <Link to="/dashboard/msme" data-id="element-1962">
              <Button variant="primary" data-id="element-1963">Fund Your Growth</Button>
            </Link>
            <Link to="/dashboard/investor" data-id="element-1964">
              <Button variant="secondary" data-id="element-1965">Invest with Impact</Button>
            </Link>
          </div>
        </div>
      </section>
    </div>;
};
export default LandingPage;